/*
  EDC Satovi – stranica proizvoda (faza 1)
  Učitava se samo kad je u sekciji "Proizvod" uključeno "EDC izgled".
  Sadrži:
    1) <edc-delivery>   – računa datum isporuke (beogradsko vreme, rok, vikendi, praznici)
    2) <edc-sticky-atc> – lepljiva traka "Dodaj u korpu" na telefonu
    3) klik na ocenu prodavnice vodi do recenzija
  Sve je zaštićeno: ako nešto ne postoji na stranici, kod samo preskoči, ne ruši ostatak stranice.
*/
(function () {
  'use strict';

  /* ---------- 1) DATUM ISPORUKE ---------- */

  var DAYS = ['u nedelju', 'u ponedeljak', 'u utorak', 'u sredu', 'u četvrtak', 'u petak', 'u subotu'];
  var MONTHS = ['jan.', 'feb.', 'mar.', 'apr.', 'maja', 'juna', 'jula', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'];

  // Trenutno vreme u Beogradu, bez obzira na vremensku zonu telefona.
  function belgradeNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Belgrade',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date());
      var get = function (t) {
        for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parseInt(parts[i].value, 10);
        return NaN;
      };
      var r = { y: get('year'), m: get('month'), d: get('day'), h: get('hour') % 24, min: get('minute') };
      if (isNaN(r.y) || isNaN(r.h)) throw new Error('intl');
      return r;
    } catch (e) {
      var n = new Date();
      return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), h: n.getHours(), min: n.getMinutes() };
    }
  }

  // Datumi se drže u UTC ponoći, da letnje/zimsko računanje vremena ne pomera dane.
  function D(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
  function addDays(dt, n) { return new Date(dt.getTime() + n * 86400000); }
  function key(dt) { return dt.toISOString().slice(0, 10); }

  // Pravoslavni Uskrs (julijanski računski postupak + 13 dana, važi 1900–2099).
  function orthodoxEaster(y) {
    var a = y % 4, b = y % 7, c = y % 19;
    var d = (19 * c + 15) % 30;
    var e = (2 * a + 4 * b - d + 34) % 7;
    var month = Math.floor((d + e + 114) / 31);
    var day = ((d + e + 114) % 31) + 1;
    return addDays(D(y, month, day), 13);
  }

  var holidayCache = {};
  function holidaysFor(y) {
    if (holidayCache[y]) return holidayCache[y];
    var set = {};
    function add(dt) { set[key(dt)] = true; }

    add(D(y, 1, 7)); // Božić (bez pomeranja)

    // Uskrs: Veliki petak, subota, nedelja, ponedeljak (dodaje se PRE pomeranja ispod,
    // da bi npr. 2027. Praznik rada u nedelju pomerio slobodan dan na utorak, jer je ponedeljak već Uskrs)
    var easter = orthodoxEaster(y);
    add(addDays(easter, -2));
    add(addDays(easter, -1));
    add(easter);
    add(addDays(easter, 1));

    // Državni praznici: ako padne u nedelju, ne radi se prvi sledeći radni dan.
    var groups = [
      [D(y, 1, 1), D(y, 1, 2)],     // Nova godina
      [D(y, 2, 15), D(y, 2, 16)],   // Sretenje
      [D(y, 5, 1), D(y, 5, 2)],     // Praznik rada
      [D(y, 11, 11)]                // Dan primirja
    ];
    groups.forEach(function (g) {
      g.forEach(add);
      var last = g[g.length - 1];
      var hitsSunday = g.some(function (dt) { return dt.getUTCDay() === 0; });
      if (hitsSunday) {
        var next = addDays(last, 1);
        while (next.getUTCDay() === 0 || next.getUTCDay() === 6 || set[key(next)]) next = addDays(next, 1);
        add(next);
      }
    });


    holidayCache[y] = set;
    return set;
  }

  function makeCalendar(extraText, saturdayDelivery) {
    var extra = {};
    (String(extraText || '').match(/\d{4}-\d{2}-\d{2}/g) || []).forEach(function (k) { extra[k] = true; });
    function isHoliday(dt) {
      var k = key(dt);
      return !!(extra[k] || holidaysFor(dt.getUTCFullYear())[k]);
    }
    return {
      // Dan kad šaljemo: pon–pet, nije praznik
      isShipDay: function (dt) {
        var w = dt.getUTCDay();
        return w >= 1 && w <= 5 && !isHoliday(dt);
      },
      // Dan kad kurir isporučuje: pon–pet (+ subota ako je uključeno), nije praznik
      isDeliveryDay: function (dt) {
        var w = dt.getUTCDay();
        if (w === 0) return false;
        if (w === 6 && !saturdayDelivery) return false;
        return !isHoliday(dt);
      }
    };
  }

  // Glavna računica – izdvojena da može da se testira.
  function computeEta(now, opts) {
    var cal = makeCalendar(opts.holidays, opts.saturday);
    var today = D(now.y, now.m, now.d);
    var minutesNow = now.h * 60 + now.min;
    var cutoffMin = opts.cutoff * 60;

    var shipToday = cal.isShipDay(today) && minutesNow < cutoffMin;
    var ship = today;
    if (!shipToday) {
      ship = addDays(today, 1);
      var guard = 0;
      while (!cal.isShipDay(ship) && guard++ < 30) ship = addDays(ship, 1);
    }

    var arrive = ship;
    var left = Math.max(1, opts.days);
    var guard2 = 0;
    while (left > 0 && guard2++ < 30) {
      arrive = addDays(arrive, 1);
      if (cal.isDeliveryDay(arrive)) left--;
    }

    var diff = Math.round((arrive - today) / 86400000);
    var w = arrive.getUTCDay();
    var dateTxt = arrive.getUTCDate() + '. ' + MONTHS[arrive.getUTCMonth()];
    var whenLong = diff === 1 ? 'sutra, ' + DAYS[w] + ' ' + dateTxt : DAYS[w] + ', ' + dateTxt;
    var whenShort = diff === 1 ? 'stiže sutra' : 'stiže ' + DAYS[w];

    return { shipToday: shipToday, arrive: key(arrive), whenLong: whenLong, whenShort: whenShort };
  }

  window.EDC = window.EDC || {};
  window.EDC.computeEta = computeEta;

  if (window.customElements && !customElements.get('edc-delivery')) {
    customElements.define('edc-delivery', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.row = this.querySelector('[data-edc-eta]');
        this.text = this.querySelector('[data-edc-eta-text]');
        this.available = this.dataset.available !== 'false';
        this.render();

        var self = this;
        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
            if (!evt || !evt.data || evt.data.sectionId !== self.dataset.section) return;
            var v = evt.data.variant;
            self.available = !!(v && v.available);
            self.render();
          });
        }
      }
      disconnectedCallback() { if (this.unsub) this.unsub(); this._ready = false; }
      render() {
        if (!this.row || !this.text) return;
        if (!this.available) {
          this.row.hidden = true;
          window.EDC.eta = null;
          document.dispatchEvent(new CustomEvent('edc:eta', { detail: null }));
          return;
        }
        try {
          var cutoff = parseInt(this.dataset.cutoff, 10);
          var eta = computeEta(belgradeNow(), {
            cutoff: isNaN(cutoff) ? 14 : cutoff,
            days: parseInt(this.dataset.days, 10) || 1,
            saturday: this.dataset.saturday === 'true',
            holidays: this.dataset.holidays
          });
          var lead = eta.shipToday ? 'Poruči do <strong>' + (isNaN(cutoff) ? 14 : cutoff) + 'h</strong>' : 'Poruči sada';
          this.text.innerHTML = lead + ' → stiže <strong>' + eta.whenLong + '</strong>';
          this.row.hidden = false;
          window.EDC.eta = eta;
          document.dispatchEvent(new CustomEvent('edc:eta', { detail: eta }));
        } catch (e) {
          this.row.hidden = true; // ako bilo šta pođe naopako, red se samo ne prikaže
        }
      }
    });
  }

  /* ---------- 2) LEPLJIVA TRAKA "DODAJ U KORPU" ---------- */

  if (window.customElements && !customElements.get('edc-sticky-atc')) {
    customElements.define('edc-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        // U prozoru "Brzo dodavanje" (sa stranice kolekcije) traka ne treba.
        if (this.closest('quick-add-modal')) { this.remove(); return; }
        // Premeštamo traku direktno u <body>, da je ništa iznad ne bi "zarobilo" (transform, overflow).
        if (this.parentElement !== document.body) {
          var sid = this.dataset.section;
          document.querySelectorAll('body > edc-sticky-atc').forEach(function (n) {
            if (n.dataset.section === sid) n.remove(); // stara kopija posle osvežavanja u uređivaču
          });
          document.body.appendChild(this);
          return; // connectedCallback će se pozvati ponovo, sada u <body>
        }
        if (this._ready) return;
        this._ready = true;
        this.btn = this.querySelector('.edc-sticky__btn');
        this.priceEl = this.querySelector('[data-edc-sticky-price]');
        this.etaEl = this.querySelector('[data-edc-sticky-eta]');
        this.visible = false;

        var self = this;
        this.onClick = function () {
          var b = self.mainBtn();
          if (b && !b.disabled) b.click();
        };
        this.btn.addEventListener('click', this.onClick);

        this.onEta = function (e) { self.setEta(e.detail); };
        document.addEventListener('edc:eta', this.onEta);
        this.setEta(window.EDC && window.EDC.eta);

        this.check = this.check.bind(this);
        this.ticking = false;
        this.onScroll = function () {
          if (self.ticking) return;
          self.ticking = true;
          requestAnimationFrame(function () { self.ticking = false; self.check(); });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);

        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, function () {
            setTimeout(function () { self.readPrice(); self.check(); }, 50);
          });
        }
        this.readPrice();
        this.check();
      }
      disconnectedCallback() {
        if (!this._ready) return;
        this._ready = false;
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('edc:eta', this.onEta);
        if (this.unsub) this.unsub();
        document.body.classList.remove('edc-sticky-on');
      }
      mainBtn() { return document.getElementById('ProductSubmitButton-' + this.dataset.section); }
      readPrice() {
        var wrap = document.getElementById('price-' + this.dataset.section);
        if (!wrap || !this.priceEl) return;
        var sale = wrap.querySelector('.price--on-sale');
        var p = sale
          ? wrap.querySelector('.price__sale .price-item--last')
          : wrap.querySelector('.price__regular .price-item--regular');
        if (p) this.priceEl.textContent = p.textContent.trim();
      }
      setEta(eta) {
        if (this.etaEl) this.etaEl.textContent = eta && eta.whenShort ? eta.whenShort : '';
      }
      check() {
        var b = this.mainBtn();
        var show = false;
        if (b && window.innerWidth < 750) {
          var r = b.getBoundingClientRect();
          show = r.bottom < 0 && !b.disabled;
        }
        if (show === this.visible) return;
        this.visible = show;
        if (show) this.readPrice();
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        this.btn.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('edc-sticky-on', show);
      }
    });
  }

  /* ---------- 3) KLIK NA OCENU -> RECENZIJE ---------- */

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-edc-scroll]');
    if (!a) return;
    var sel = a.getAttribute('data-edc-scroll');
    var target = null;
    try { if (sel) target = document.querySelector(sel); } catch (err) { target = null; }
    if (!target) {
      target = document.querySelector('#edc-reviews, .jdgm-rev-widg, .jdgm-review-widget, #judgeme_product_reviews');
    }
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (a.getAttribute('href') === '#') {
      e.preventDefault();
    }
  });

  /* ---------- 4) ZAMENA ENGLESKOG TEKSTA IZ APLIKACIJA (rezervno rešenje) ---------- */
  // Aplikacija SW Back in Stock na jeziku "bs" ponekad prikazuje svoj engleski tekst.
  // Ovde menjamo samo TAČNO ove rečenice (velika/mala slova nisu bitna). Ako aplikacija promeni tekst,
  // zamena se samo ne desi – ništa se ne lomi. Dodaj red ako vidiš još neki engleski tekst.
  var EDC_TEXT = {
    'email me when available': 'Kada će biti ponovo dostupno?',
    'notify me when available': 'Kada će biti ponovo dostupno?',
    'notify me': 'Javi mi kad stigne'
  };
  function edcFixTexts(root) {
    if (!root || !root.querySelectorAll) return;
    var nodes = root.querySelectorAll('button, a, span, div, p, label, h2, h3, input[type="submit"], input[placeholder]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.tagName === 'INPUT') {
        var v = (el.value || '').trim().toLowerCase();
        if (EDC_TEXT[v]) el.value = EDC_TEXT[v];
        continue;
      }
      if (el.children.length) continue; // samo elementi koji sadrže čist tekst
      var t = (el.textContent || '').trim().toLowerCase();
      if (t && EDC_TEXT[t]) el.textContent = EDC_TEXT[t];
    }
  }
  (function () {
    var pending = false;
    var run = function () {
      pending = false;
      edcFixTexts(document.body);
    };
    var schedule = function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(run); // najviše jednom po frejmu, bez obzira koliko promena ima
    };
    var start = function () {
      run();
      // Pratimo i kasnije promene (npr. forma koja se otvori na klik).
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();

  /* ---------- 5) OZNAKE NA SLICI: stanje + veličina na zglobu ---------- */

  if (window.customElements && !customElements.get('edc-media-badges')) {
    customElements.define('edc-media-badges', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var self = this;
        try { this.states = JSON.parse(this.dataset.edcStock || '{}'); } catch (e) { this.states = {}; }
        this.badge = this.querySelector('[data-edc-stock-badge]');
        this.badgeText = this.querySelector('[data-edc-stock-text]');
        if (this.badge) this.setStock(this.badge.dataset.variant);

        // Oznaka veličine ide u slajd sa slikom sata na ruci (samo glavna galerija, ne sličice).
        var wrist = this.querySelector('[data-edc-wrist]');
        if (wrist) {
          var gallery = document.getElementById('GalleryViewer-' + this.dataset.section);
          var slide = gallery && gallery.querySelector('[data-media-id="' + wrist.dataset.mediaId + '"]');
          if (slide) {
            slide.classList.add('edc-has-wrist');
            slide.appendChild(wrist);
            wrist.hidden = false;
          }
        }

        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
            if (!evt || !evt.data || evt.data.sectionId !== self.dataset.section) return;
            var v = evt.data.variant;
            if (v) self.setStock(String(v.id));
          });
        }
      }
      disconnectedCallback() { if (this.unsub) this.unsub(); this._ready = false; }
      setStock(id) {
        if (!this.badge) return;
        var st = this.states[id] || 'out';
        var cls = 'in', txt = this.dataset.txtIn;
        if (st.indexOf('low:') === 0) { cls = 'low'; txt = (this.dataset.txtLow || '').replace('[broj]', st.slice(4)); }
        else if (st === 'back') { cls = 'back'; txt = this.dataset.txtBack; }
        else if (st === 'out') { cls = 'out'; txt = this.dataset.txtOut; }
        if (!txt) { this.badge.hidden = true; return; }
        this.badge.className = 'edc-mb__stock edc-mb__stock--' + cls;
        this.badgeText.textContent = txt;
        this.badge.hidden = false;
      }
    });
  }
})();
